// Valenoro Theme — Galerie-Wechsel
function vnSwap(el, src){
  var main = document.getElementById('vnMainImg');
  if(main){ main.src = src; }
  document.querySelectorAll('.vn-thumb').forEach(function(t){ t.classList.remove('active'); });
  el.classList.add('active');
}
